import React from "react";
import { Outlet } from "react-router-dom";

function AppWrapper() {
  return (
    <>
      <Outlet />
    </>
  );
}

export default AppWrapper;
